<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .top-section {
    display: grid;
    gap: utils.in_rem(16px);
    margin-bottom: utils.in_rem(16px);
  }
</style>

<script>
  import SettingToggle from "../../../../components/shared/SettingToggle.svelte";
  import { integrationStore } from "../../../../stores";

  const requiredKeys = [
    "updateInResponseToChanges",
    "blockOutreachToOffLimits",
  ];

  $: toggleSettings = $integrationStore
    .getSettings("general")
    .filter(
      (setting) =>
        setting.kind === "checkbox" && requiredKeys.includes(setting.key)
    );
</script>

<div class="top-section">
  {#each toggleSettings as setting (setting.key)}
    <SettingToggle {setting} />
  {/each}
</div>
